import React from "react";
import FrontHeader from "../../shared/FrontHeader/FrontHeader";
import FrontFooter from "../../shared/FrontFooter/FrontFooter";
import FrontMainNav from "../../shared/FrontMainNav/FrontMainNav";

import ImgQuiSuis from '..//..//..//assets/images/appImages/img-qui-suis.png'
// TODO: remplacez ce chemin par la vraie photo du fondateur
import FounderPhoto from '..//..//..//assets/images/appImages/fondateur_coran.png'

// Images pour "Nos valeurs" (remplacent les icônes lucide-react)
// TODO: remplacez ces chemins par vos vraies images
import ValeurQualiteImg from '..//..//..//assets/images/appImages/act3.png'
import ValeurSatisfactionImg from '..//..//..//assets/images/appImages/at4.png'
import ValeurEthiqueImg from '..//..//..//assets/images/appImages/act5.png'
import ValeurTransparenceImg from '..//..//..//assets/images/appImages/act2.png'
import ValeurInnovationImg from '..//..//..//assets/images/appImages/act1.png'

// Photos de l'équipe
// TODO: remplacez ces chemins par les vraies photos des membres
import SeydouPhoto from '..//..//..//assets/images/appImages/logo-coransoigne-removebg-preview.png'
import AbdoulPhoto from '..//..//..//assets/images/appImages/logo-coransoigne-removebg-preview.png'

const valeurs = [
  { id: "qualite", img: ValeurQualiteImg, title: "Qualité et authenticité" },
  { id: "satisfaction", img: ValeurSatisfactionImg, title: "Satisfaction client" },
  { id: "ethique", img: ValeurEthiqueImg, title: "Respect des principes éthiques et islamiques" },
  { id: "transparence", img: ValeurTransparenceImg, title: "Transparence et confiance" },
  { id: "innovation", img: ValeurInnovationImg, title: "Innovation et amélioration continue" },
];

const equipe = [
  { id: "seydou", img: SeydouPhoto, name: "Seydou Ly", role: "Fondateur et Directeur Général" },
  { id: "abdoul", img: AbdoulPhoto, name: "Abdoul DIALLO", role: "Responsable Commercial" },
];

function WhoWeAre() {
  return (
    <div className="landing-page-component">
      <FrontHeader />
      <div className="page-content who-we-are-page pb-5">
        <FrontMainNav />
        <h1 className="qui-sommes-nous-main-title">Qui sommes-nous ?</h1>

        <section className="qui-sommes-nous-about">
          <div className="container">
            <div className="row align-items-flex-start qui-sommes-nous-top-row">
              <div className="col-lg-5 col-md-6">
                <div className="qui-sommes-nous-image-wrapper">
                  <img
                    src={ImgQuiSuis}
                    alt="img-qui-suis- Solutions technologiques"
                    className="qui-sommes-nous-image"
                  />
                </div>
              </div>
              <div className="col-lg-7 col-md-6 qui-sommes-nous-text-col">
                <h2 className="qui-sommes-nous-company-title">LE CORAN SOIGNE</h2>
                <div className="qui-sommes-nous-content">
                  <p className="text-qui-sommes-nous">
                    LE CORAN SOIGNE est une entreprise spécialisée dans le bien-être,
                    les soins naturels et l'accompagnement spirituel. Notre mission est d'aider nos clients à améliorer leur qualité de vie grâce à des produits naturels sélectionnés avec soin et à des services respectueux des valeurs éthiques et islamiques.
                  </p>
                </div>
              </div>
            </div>

            {/* Nos valeurs : 5 cartes avec IMAGES (plus d'icônes) */}
            <div className="qui-sommes-nous-values-row">
              <h2 className="qui-sommes-nous-values-title py-4">Nos valeurs</h2>
              <div className="nos-valeurs-cards nos-valeurs-cards-5">
                {valeurs.map((valeur) => (
                  <div className="nos-valeurs-card" key={valeur.id}>
                    <div className="nos-valeurs-card-inner nos-valeurs-card-inner-image">
                      <h4 className="nos-valeurs-card-title">{valeur.title}</h4>
                      <div className="nos-valeurs-icon-circle">
                        <img
                          src={valeur.img}
                          alt={valeur.title}
                          className="nos-valeurs-icon-image"
                        />
                      </div>
                      
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Section Notre équipe */}
        <section className="notre-equipe-section">
          <div className="container">
            <div className="notre-equipe-header">
              <h2 className="notre-equipe-title">Notre équipe</h2>
            </div>
            <div className="row notre-equipe-cards">
              {equipe.map((membre) => (
                <div className="col-md-6" key={membre.id}>
                  <div className="notre-equipe-card ">
                    <div className="notre-equipe-photo-wrapper">
                      <img
                        src={membre.img}
                        alt={membre.name}
                        className="notre-equipe-photo"
                      />
                    </div>
                    <p className="notre-equipe-card-name">{membre.name}</p>
                    <p className="notre-equipe-card-role">{membre.role}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Section Mot du fondateur */}
        <section className="mot-fondateur-section">
          <div className="container mot-fondateur-container">
            <div className="mot-fondateur-content-row">
              <div className="mot-fondateur-text-col">
                <h2 className="mot-fondateur-title text-black">Mot du fondateur</h2>
                <p className="mot-fondateur-text">Bienvenue chez LE CORAN SOIGNE.</p>
                <p className="mot-fondateur-text">
                  Notre ambition est d'offrir à nos clients des produits et
                  services de qualité qui contribuent à leur bien-être
                  physique, moral et spirituel. Nous plaçons la satisfaction
                  de nos clients au cœur de nos priorités et nous nous
                  engageons à toujours servir avec sérieux, professionnalisme
                  et respect.
                </p>
                <p className="mot-fondateur-text">Merci pour votre confiance.</p>
                <p className="mot-fondateur-signature">Seydou Ly</p>
                <p className="mot-fondateur-role">Fondateur et Directeur Général</p>
              </div>
              <div className="mot-fondateur-image-col">
                <img
                  src={FounderPhoto}
                  alt="Seydou Ly - Fondateur et Directeur Général"
                  className="mot-fondateur-image"
                />
              </div>
            </div>
          </div>
        </section>
      </div>
      <FrontFooter />
    </div>
  );
}

export default WhoWeAre;